import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { logger } from "@/lib/logger";
import { Card, CardContent } from "@/components/ui/card";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import DigestConfigCard from "@/pages/alertas/DigestConfigCard";
import DigestLastRunCard from "@/pages/alertas/DigestLastRunCard";

export default function AlertasEmailPage() {
  const [cfg, setCfg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get("/pendencias/config");
      setCfg(r.data);
    } catch (e) {
      logger.error("Falha ao carregar config", e);
      toast.error(e.response?.data?.detail || "Falha ao carregar");
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const salvar = async () => {
    if (!cfg) return;
    setSaving(true);
    try {
      const body = {
        enabled: cfg.enabled,
        hour: cfg.hour,
        minute: cfg.minute,
        dias_semana: cfg.dias_semana,
      };
      const r = await api.put("/pendencias/config", body);
      setCfg(r.data);
      toast.success("Configuração salva!");
    } catch (e) {
      logger.error("Falha ao salvar", e);
      toast.error(e.response?.data?.detail || "Falha ao salvar");
    } finally { setSaving(false); }
  };

  const enviarTeste = async () => {
    setTesting(true);
    try {
      const r = await api.post("/pendencias/testar");
      const s = r.data.summary || {};
      if (r.data.ok) {
        toast.success(`Teste enviado para ${r.data.destinatario} (${s.total_novas || 0} novas · ${s.total_pendentes || 0} docs · ${s.total_otps || 0} OTPs)`);
      } else {
        toast.warning("Teste processado mas e-mail não foi enviado — verifique o Resend.");
      }
    } catch (e) {
      logger.error("Falha no teste", e);
      toast.error(e.response?.data?.detail || "Falha ao enviar teste");
    } finally { setTesting(false); }
  };

  if (!cfg) {
    return <div className="p-6 flex items-center gap-2 text-slate-500">
      <Loader2 className="w-4 h-4 animate-spin" /> Carregando...
    </div>;
  }

  return (
    <div className="space-y-6" data-testid="alertas-email-page">
      <div>
        <h1 className="text-3xl font-black text-[#083CA6] flex items-center gap-2">
          <Mail className="w-7 h-7" /> Alertas por E-mail
        </h1>
        <p className="text-sm text-slate-600">
          Resumo diário enviado aos funcionários com inscrições que precisam de atenção.
        </p>
      </div>

      <DigestConfigCard
        cfg={cfg}
        setCfg={setCfg}
        loading={loading}
        saving={saving}
        testing={testing}
        onSave={salvar}
        onTest={enviarTeste}
      />

      <DigestLastRunCard cfg={cfg} />

      <Card className="border-blue-200 bg-blue-50/40">
        <CardContent className="p-4 text-xs text-slate-600 space-y-1">
          <div><strong className="text-slate-800">Como funciona:</strong></div>
          <div>• Cada funcionário recebe apenas se tiver e-mail cadastrado E se houver pendências para reportar.</div>
          <div>• Funcionários podem optar por não receber via <code className="bg-white px-1 rounded">Usuários → Editar → Receber e-mail</code>.</div>
          <div>• O botão <em>Enviar teste</em> envia o resumo apenas para o seu próprio e-mail, independente do opt-out.</div>
        </CardContent>
      </Card>
    </div>
  );
}
